import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import styles from '../PrivacyPolicyContents.module.css';

const PrivacyPolicyContentsOld = () => {
  return (
    <Container>
      <div className={styles.tncTitle}>개인정보 처리방침</div>
      <Row>
        <Col>
          <div>
            <p>
              <center>
                <div className={styles.title}>
                  2021년 2월 18일자로 <a href='/privacypolicy'>신규 개인정보 처리방침</a>이 적용됩니다.
                </div>
              </center>
            </p>

            <p>
              <div className={styles.title}>2019년 9월 16일 개정</div>
            </p>
            <p>
              <div className={styles.title}>1. 개인정보의 처리 목적</div>
            </p>
            <p>- 이용자 본인 확인 등 회원관리</p>
            <p>- 서비스 제공·운영 및 서비스 개발·개선</p>
            <p>- 부정 이용 행위 방지 및 제재</p>
            <p>- 고지사항 전달</p>
            <p>
              <div className={styles.title}>2. 개인정보의 처리 및 보유 기간</div>
            </p>
            <p>수집한 개인정보는 회원탈퇴시까지 처리 및 보유합니다.</p>
            <p>단 불량 이용자의 재가입 방지 등의 사유를 위해서 보존될 수 있으며,</p>
            <p>
              상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우
              회사는 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의
              목적으로만 이용하며 보존기간은 아래와 같습니다.
              <br />
              -계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)
              <br />
              -대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)
              <br />
              -소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래 등에서의 소비자보호에 관한 법률)
            </p>
            <p>
              <div className={styles.title}>3. 개인정보의 제3자 제공</div>
            </p>
            <p>
              회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
              <br />
              -이용자들이 사전에 동의한 경우
              <br />
              -법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우
            </p>
            <p>
              <div className={styles.title}>4. 개인정보처리의 위탁</div>
            </p>
            <p>해당사항 없습니다.</p>
            <p>
              <div className={styles.title}>5. 정보주체와 법정대리인의 권리·의무 및 그 행사방법</div>
            </p>
            <p>
              이용자는 legal@legalengine.co.kr으로 이메일을 보내 개인정보 보호법에 명시된 권리들을 행사할 수 있습니다.
            </p>
            <p>
              <div className={styles.title}>6. 처리하는 개인정보의 항목</div>
            </p>
            <p>- 회원가입 시점에 이름, 이메일, 비밀번호를 필수항목으로 수집합니다.</p>
            <p>
              - 서비스를 이용할 때 IP 주소, 쿠키, 방문일시·방문페이지·검색어 등의 서비스 이용 기록, 기기 정보를 서버
              로그에 자동으로 수집하고 저장합니다.
            </p>
            <p>
              - 신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 전달, 인구통계학적 특성에 따른 서비스 제공 및 광고
              게재, 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계 등에 사용될 수 있습니다.
            </p>
            <p>- 개인을 위해 특성화된 검색결과를 제공하기 위해 검색결과 등을 저장합니다.</p>
            <p>
              <div className={styles.title}>7. 개인정보의 파기</div>
            </p>
            <p>
              - 원칙적으로 회원탈퇴시 지체없이 개인정보를 파기합니다. 단, 법령에서 일정기간 정보의 보관을 규정하는 경우
              해당 법령을 따릅니다.
            </p>
            <p>- 개인정보의 파기 방법은 다음과 같습니다.</p>
            <p>- 전자적인 형태로 기록 저장된 개인정보는 복원이 불가능한 방법으로 파기합니다.</p>
            <p>- 종이 문서에 기록된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.</p>
            <p>
              <div className={styles.title}>8. 개인정보의 안전성 확보 조치</div>
            </p>
            <p>- 개인정보에 접근할 수 있는 사람을 최소화하고 있습니다.</p>
            <p>- 기술적 조치: 개인 정보의 암호화, 개인정보를 보관하는 시스템의 접근권한 관리, 접근통제시스템 설치</p>
            <p>
              <div className={styles.title}>9. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</div>
              <br />
              회사는 귀하의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’ 등을 운용합니다. 쿠키란 회사의 웹사이트를
              운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에
              저장됩니다
              <br />
              <br />
              9.1. 쿠키 등 사용목적
            </p>
            <p>
              -PC 인증 (모바일 디바이스 인증 포함) -회원과 비회원의 접속빈도나 방문시간 등을 분석, 이용자의 취향과
              관심분야를 파악, 각종 이벤트 참여정도 및 방문회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공
            </p>
            <p>
              <br />
              9.2. 쿠키 설정 거부 방법
            </p>
            <p>
              귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 귀하는 웹브라우저에서 옵션을 설정함으로써 모든
              쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
              단, 귀하께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.
            </p>
            <p>
              <br />
              9.3. 쿠키 설정 거부 방법 예시
            </p>
            <p>인터넷 익스플로어의 경우 웹 브라우저 상단의 도구 &gt; 인터넷 옵션 &gt; 개인정보&gt; 고급에서 설정</p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicyContentsOld;
